<template>
  <div class="who-we-are">
    <b-container class="content">
      <h1>{{$t('our-team-title')}}</h1>

      <b-row class="item">
        <b-col cols="12" sm="12" md="8" xl="8">
          <div class="user-info">
            <p class="user-name">{{$t('our-teammate-1-name')}}</p>
            <p class="position">{{$t('our-teammate-1-position')}}</p>
            <p v-html="$t('our-teammate-1-description')" class="describe"></p>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="4" xl="4">
          <b-img fluid src="../assets/imgs/our-team-img-1.png"></b-img>
        </b-col>
      </b-row>

      <b-row class="item">
        <b-col cols="12" sm="12" md="8" xl="8">
          <div class="user-info">
            <p class="user-name">{{$t('our-teammate-2-name')}}</p>
            <p class="position">{{$t('our-teammate-2-position')}}</p>
            <p v-html="$t('our-teammate-2-description')" class="describe"></p>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="4" xl="4">
          <b-img fluid src="../assets/imgs/our-team-img-2.png"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'SmartVenues',
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
  .who-we-are {
    .platform-title-img {
      width: 50%;
      bottom: 30px;
    }

    .content {
      margin-top: 5rem;
      margin-bottom: 10rem;
    }

    .user-info {
      .user-name {
        font-size: 2rem;
        font-weight: bold;
      }
      .position {
        font-size: 1.5rem;
        font-weight: 500;
      }
      .describe {
        font-size: 16px;
        color: #646464;
      }
    }

    .item {
      padding: 15px 0;
      margin-top: 30px;

    }
  }
</style>
